import apiFarms from "../config/api_farms";
import getHeaders from "./getHeaders";

export function indexAll(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/retreats`,
    getHeaders(false, signal)
  );
}

export function getOnlyActives(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/retreats?onlyActives=true`,
    getHeaders(false, signal)
  );
}

export function findById(payload) {
  const { groupId, farmId, id } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/retreats/${id}`,
    getHeaders(false, null)
  );
}

export function save(payload) {
  const { groupId, farmId, body } = payload;

  return apiFarms.post(`/bovexo/${groupId}/farms/${farmId}/retreats`,
    body,
    getHeaders(false, null)
  );
}

export function update(payload) {
  const { groupId, farmId, id, body } = payload;

  return apiFarms.patch(`/bovexo/${groupId}/farms/${farmId}/retreats/${id}`,
    body,
    getHeaders(false, null)
  );
}

export function Inactivate(payload) {
  const { groupId, farmId, id } = payload;

  return apiFarms.put(`/bovexo/${groupId}/farms/${farmId}/retreats/${id}/inactivate`,
    null,
    getHeaders(false, null)
  );
}

export function Activate(payload) {
  const { groupId, farmId, id } = payload;

  return apiFarms.put(`/bovexo/${groupId}/farms/${farmId}/retreats/${id}/activate`,
    null,
    getHeaders(false, null)
  );
}

export function deleteById(payload) {
  const { groupId, farmId, id } = payload;

  return apiFarms.delete(`/bovexo/${groupId}/farms/${farmId}/retreats/${id}`,
    getHeaders(false, null)
  );
}